module.exports = __webpack_public_path__ + "img/fuel-injection-schematic-dark.3d6877d4.png";